import { render, staticRenderFns } from "./CrewAssignmentDashboard.vue?vue&type=template&id=448a8879&scoped=true"
import script from "./CrewAssignmentDashboard.vue?vue&type=script&lang=js"
export * from "./CrewAssignmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./CrewAssignmentDashboard.vue?vue&type=style&index=0&id=448a8879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a8879",
  null
  
)

export default component.exports